//
//
//
//
//
//
//
//
//
//
//
//
//

 import { mapState, mapMutations } from "vuex";

export default {
     data(){
       return {

       }
   },
   created() {     
     const storedHideApp = this.getLocalStorageWithExpiry('isHideAppDialog');
     if(storedHideApp === 'false') this.$store.commit('setIsHideAppDialog',false);
   },
  computed: {
     ...mapState({
       isApp: state => state.isApp, //是否在app打开
       isHideAppDialog: state => state.isHideAppDialog, //是否隐藏app导航栏 用户点击
     })
   },
   methods: {
     closeDialog(){
       this.$store.commit('setIsHideAppDialog',false);
       this.setLocalStorageWithExpiry('isHideAppDialog', 'false', 24 * 60 * 60 * 1000);
     },
     // 存储数据，并设置24小时过期
     setLocalStorageWithExpiry(key, value, ttl) {
       const now = new Date();
       // ttl是过期时间，单位为毫秒
       const item = {
         value: value,
         expiry: now.getTime() + ttl,
       };
       localStorage.setItem(key, JSON.stringify(item));
     },
     
     // 获取存储的数据
     getLocalStorageWithExpiry(key) {
       const itemStr = localStorage.getItem(key);
       if (!itemStr) {
         return null;
       }
       const item = JSON.parse(itemStr)
       const now = new Date();
       if (now.getTime() > item.expiry) {
         localStorage.removeItem(key);
         return null;
       }
       return item.value;
     }
   },
   mounted() {

   },

}



// WEBPACK FOOTER //
// ./src/pages/build922/views/components/app-download-dialog/index.vue